import "core-js/modules/es.symbol.js";
var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/logApiError.ts";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as Sentry from '@sentry/browser';
import { ServerUnavailableException } from '@gmini/utils/lib/fetchService/exceptions';
var excludedCodes = ['GROUPING_CONDITION_ELEMENT_PROPERTIES_IS_GREATER_MAX_ALLOWED'];
export function logApiError(err) {
  if (err instanceof ServerUnavailableException) {
    // Не отправляем в сентри ошибки 503
    return;
  }

  var res = err.res,
      error = _objectWithoutProperties(err, ["res"]);

  var errInfo = {
    req: res.req,
    error: error
  };
  var message = errorNameMap[err.status];
  console.error("Api call error:\n ".concat(JSON.stringify(errInfo, null, 2)));

  if (err.res.data) {
    message = "".concat(message, ": ").concat(err.res.data.message);
  }

  if (err.status === 'fail' && excludedCodes.includes(err.data.errorCode)) {
    return;
  }

  Sentry.captureEvent({
    message: message,
    extra: errInfo
  });
}
export var errorNameMap = {
  error: 'ошибка сервера error',
  fail: 'ошибка сервера fail',
  'io-ts error': 'ошибка валидации API',
  'unknown error': 'неизвесная ошибка'
};